/* @flow */
const prefix = str => `station/summaries/${str}`;

export const FETCH_SUMMARY = prefix('FETCH_SUMMARY');
export const FETCH_SUMMARY_SUCCESS = prefix('FETCH_SUMMARY_SUCCESS');
export const FETCH_SUMMARY_FAILURE = prefix('FETCH_SUMMARY_FAILURE');

export const FETCH_SUMMARIES_FOR_REPORTS = prefix('FETCH_SUMMARIES_FOR_REPORTS');
export const FETCH_SUMMARIES_FOR_REPORTS_SUCCESS = prefix('FETCH_SUMMARIES_FOR_REPORTS_SUCCESS');
export const FETCH_SUMMARIES_FOR_REPORTS_FAILURE = prefix('FETCH_SUMMARIES_FOR_REPORTS_FAILURE');

export const CLEAR_SUMMARY = prefix('CLEAR_SUMMARY');

export const SHOW_ENTIRE_SUMMARY_TOGGLE = prefix('SHOW_ENTIRE_SUMMARY_TOGGLE');
export const FOLD_ENTIRE_SUMMARY = prefix('FOLD_ENTIRE_SUMMARY');

export const FETCH_CS_ENCLAVE_SOURCE_MAP = prefix('FETCH_CS_ENCLAVE_SOURCE_MAP');
export const FETCH_CS_ENCLAVE_SOURCE_SUCCESS = prefix('FETCH_CS_ENCLAVE_SOURCE_SUCCESS');
export const FETCH_CS_ENCLAVE_SOURCE_FAILURE = prefix('FETCH_CS_ENCLAVE_SOURCE_FAILURE');



// WEBPACK FOOTER //
// ./src/app/modules/summaries/action-types.js